<p-toast></p-toast>
<app-topbar></app-topbar>
<main class="layout-container">
  <div class="layout-content-wrapper">
    <div class="layout-content">
       <div class="grid justify-content-center">
         <!-- Contêiner Pai -->
        <div class="col-12 md:col-8 lg:col-8">
           <!-- Botão Voltar -->
       <div class="mb-3">
        <p-button
          icon="pi pi-arrow-left"
          label="Voltar"
          severity="secondary"
          (onClick)="voltar()"
          styleClass="p-button-text"
        ></p-button>
      </div>
          <!-- Card do Prompt -->
          <div
            class="shadow-1 border-round-2xl p-4 mb-4"
            style="background-color:#fff"
          >
            <div class="resumodata border-bottom-1 surface-border pb-4">
              <div class="flex flex-column align-items-start">
                <h2 class="text-lg text-900 font-bold mb-2">
                  {{ prompt?.prompt_titulo }}
                  <div class="flex align-items-center gap-3 mb-2">
                    <!-- Foto do Usuário -->
                    <img
                      [src]="displayAvatarAutor$ | async"
                      alt="Avatar do Usuário"
                      class="border-circle"
                      style="width: 40px; height: 40px; object-fit: cover"
                    />
                    <div class="flex-grow-1">
                      <div class="flex justify-content-between align-items-center">
                        <span class="text-sm font-medium">
                          {{ displayNomeAutor$ | async }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <a
                    *ngIf="prompt?.prompt_pai as parentId"
                    [routerLink]="['/tela-prompt', parentId]"
                    class="text-primary ml-2 text-sm"
                    style="text-decoration: underline; cursor: pointer"
                  >
                    Prompt Original
                  </a>
                </h2>

                <p class="mb-2 text-sm mt-1">{{ prompt?.prompt_descricao }}</p>
                <span class="text-xs text-black-alpha-90">{{
                  prompt?.prompt_dtCriacao | date : "longDate"
                }}</span>
              </div>
            </div>

            <!-- Orientação -->
            <div class="py-1">
              <h3 class="text-sm font-medium mb-2">Orientação:</h3>
              <pre
                class="bg-bluegray-50 border-round-2xl p-3 text-sm comando-pre"
                >{{ prompt?.prompt_instrucoes }}</pre
              >
            </div>

            <!-- Comando do Prompt -->
            <div class="py-1">
              <h3 class="text-sm font-medium mb-2">Comando:</h3>
              <pre class="bg-bluegray-50 border-round-2xl p-3 text-sm comando-pre" tabindex="0"
                   (click)="campoSelecionado('Prompt')" (blur)="onBlur()">{{ prompt?.prompt_comando }}
              </pre>
            </div>

            <!-- Categorias -->
            <div class="border-bottom-1 surface-border py-2">
              <h3 class="text-sm font-medium mb-2">Categorias:</h3>
              <div class="flex gap-2 flex-wrap">
                <span *ngIf="prompt?.prompt_categoria?.length === 0">Não consta</span>
                <span
                  *ngFor="let categoria of prompt?.prompt_categoria"
                  class="badge surface-200 text-sm px-2 py-1 border-round"
                  style="background-color: var(--green-100)">
                  {{ categoria?.categoria_descricao }}
                </span>
              </div>
            </div>

            <!-- Palavras-chave (discreto) -->
            <div *ngIf="prompt?.prompt_tags?.length" class="py-1">
              <span class="text-xs text-500">Palavras-chave: </span>
              <ng-container *ngFor="let tag of prompt?.prompt_tags; let last = last">
                <span class="text-xs text-500" style="opacity: 0.85">{{ tag.tag_nome }}</span><span *ngIf="!last">, </span>
              </ng-container>
            </div>

            <!-- Botão -->
            <div
              class="md:flex justify-content-between align-items-center mt-3"
            >
              <!-- Estrelas e Avaliações -->
              <div class="flex align-items-center gap-2">
                <p-rating
                  [ngModel]="mediaAvaliacao"
                  readonly="true"
                  stars="5"
                  [cancel]="false"
                ></p-rating>
                <span class="text-sm">({{ totalAvaliacoes }} Avaliações)</span>
              </div>

              <!-- Botões -->
              <div class="flex gap-2">
                <!-- Botões -->
                <div class="flex gap-2">
                  <button
                    pButton
                    pRipple
                    type="button"
                    class="bt-tema-2"
                    (click)="abrirModalAvaliacao()"
                  >{{isMobile ? 'Avaliar' : 'Avaliar Prompt'}}</button>
                  <p-button
                    pRipple
                    type="button"
                    severity="warning"
                    (click)="duplicarPrompt(prompt)"
                  >Duplicar</p-button>
                  <button
                    pButton
                    pRipple
                    type="button"
                    class="bt-tema"
                    (click)="copiarPrompt()"
                  >Copiar</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Card de Avaliações -->
          <div
            class="shadow-1 border-round-2xl p-4 pt-2"
            style="background-color: var(--bluegray-70)"
          >
            <div class="flex justify-content-between align-items-center mb-4">
              <!-- Título -->
              <h3 class="text-lg text-900 font-bold">Avaliações:</h3>

              <!-- Filtro -->
              <p-dropdown
                [options]="opcoesFiltro"
                [(ngModel)]="filtroSelecionado"
                placeholder="Filtrar por"
                [style.width.px]="200"
                (onChange)="filtrarAvaliacoes()"
              ></p-dropdown>
            </div>

            <!-- Lista de Avaliações -->
            <div
              class="shadow-1 border-round-2xl p-4 mb-3"
              style="background-color: var(--bluegray-50)"
              *ngFor="let avaliacao of avaliacoesFiltradas"
            >
              <div class="flex align-items-center gap-3 mb-2">
                <!-- Foto do Usuário -->
                <img
                  [src]="getUserAvatar(avaliacao.usuario)"
                  alt="Avatar do Usuário"
                  class="border-circle"
                  style="width: 40px; height: 40px; object-fit: cover"
                />

                <div class="flex-grow-1">
                  <div class="flex justify-content-between align-items-center">
                    <!-- Nome e Avaliação -->
                    <span class="text-sm font-medium">{{
                      avaliacao.usuario?.usuario_nome
                    }}</span>
                    <p-rating
                      [ngModel]="avaliacao.avaliacao_valor"
                      readonly="true"
                      stars="5"
                      [cancel]="false"
                    ></p-rating>
                  </div>
                  <!-- Comentário -->
                  <p class="text-sm text-900 mt-1">
                    {{ avaliacao.avaliacao_coment }}
                  </p>
                  <!-- Data da Avaliação -->
                  <span class="text-xs text-black-alpha-90 mt-1">{{
                    avaliacao.dtcriacao | date : "longDate"
                  }}</span>
                </div>
              </div>
            </div>

            <!-- Mensagem Caso Não Haja Avaliações -->
            <div
              *ngIf="avaliacoesFiltradas.length === 0"
              class="text-center text-sm text-black-alpha-90 mb-4"
            >
              Ainda não há avaliações para este prompt.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Avaliar -->
  <p-dialog
    header="Avaliar Prompt"
    [(visible)]="modalVisivel"
    [modal]="true"
    [responsive]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '35vw' }"
    [closable]="true"
    [dismissableMask]="true"
  >
    <div class="p-fluid">
      <!-- Campo para nota -->
      <div class="my-2 flex align-items-center">
        <label for="rating" class="text-lg font-bold mr-2">Nota:</label>
        <p-rating
          [(ngModel)]="novaAvaliacao.valor"
          stars="5"
          [cancel]="false"
          class="rating-stars"
          (onRate)="atualizarLegenda($event)"
        ></p-rating>
      </div>
        <div *ngIf="legenda" class="text-xs my-2">
          {{ legenda }}
        </div>

      <!-- Campo para comentário -->
      <div class="field mt-3">
        <label for="comentario" class="text-lg font-bold mb-2"
          >Comentário</label
        >
        <textarea
          id="comentario"
          [(ngModel)]="novaAvaliacao.comentario"
          rows="4"
          placeholder="Escreva seu comentário..."
          class="p-inputtext border-round-2xl p-3"
          style="width: 100%; font-size: 1rem; resize: none"
        ></textarea>
      </div>

      <!-- Botões -->
      <div
        class="flex md:justify-content-end justify-content-center my-4 gap-2"
      >
        <p-button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-outlined p-button-danger p-button-lg"
          (click)="fecharModalAvaliacao()"
        ></p-button>
        <p-button
          label="Enviar"
          icon="pi pi-check"
          class="p-button-success p-button-lg"
          (click)="enviarAvaliacao()"
        ></p-button>
      </div>
      <div class="p-m-4">
        <div class="mb-2">
          <label for="rating" class="text- font-bold mr-2">Legenda</label>
        </div>
        <div class="pb-2 flex text-xs" *ngFor="let starCount of [1, 2, 3, 4, 5]">
          <ng-container *ngFor="let star of [].constructor(starCount)">
            <i class="pi pi-star-fill star"></i>
          </ng-container>
          <span class="ml-2">{{ getLegend(starCount) }}</span>
        </div>

      </div>
    </div>
  </p-dialog>
</main>
